import React from 'react'
import ProductsCard from '../../../component/ProductsCard'
import { useInView } from 'react-intersection-observer'
import { useTranslation } from 'react-i18next'

const CommodityBrokerage = () => {
  const [ref, inView] = useInView({triggerOnce: true})

  const {t} = useTranslation()

  const productsCardsData = [
    {
      title: t('commodityBrokerage.agroProducts'), 
      products: [
        {
          title:  t('commodityBrokerage.whiteSugar.title'), 
          desc: t('commodityBrokerage.whiteSugar.desc'), 
          photo: '/sugar.jpg',

          isModal: true,
          modalDescription: t('commodityBrokerage.whiteSugar.desc'),
          modalPhotos: [
            '/sugar/photo_1_2025-03-12_18-37-57.jpg',
            '/sugar/photo_2_2025-03-12_18-37-57.jpg',
            '/sugar/photo_3_2025-03-12_18-37-57.jpg',
            '/sugar/photo_4_2025-03-12_18-37-57.jpg'
          ]
        },
        {title:  t('commodityBrokerage.wheatFlour.title'), desc: t('commodityBrokerage.wheatFlour.desc'), photo: '/flour.jpg'},
        {title: t('commodityBrokerage.corn.title'), desc: t('commodityBrokerage.corn.desc'), photo: '/scattered-corn.jpg'},
        {
          title: t('commodityBrokerage.refinedOilItoleico.title'), 
          desc: t('commodityBrokerage.refinedOilItoleico.desc'), 
          photo: '/oil.jpg',

          isModal: true,
          modalDescription: t('commodityBrokerage.refinedOilItoleico.desc'),
          modalPhotos: [
            '/oil.jpg',
            '/oil2.jpg',
            'oils/oil4.jpg',
            'oils/oil3.jpg',
            'oil1.jpg',
            'oils/oil5.jpg',
            'oils/oil6.jpg',
          ],
          modalPhotosHeight: '!h-auto',
        },
      ]
    },
    // {
    //   title: t('commodityBrokerage.mushrooms'),
    //   products: [
    //     {
    //       title: t('commodityBrokerage.whiteMushrooms.title'), 
    //       desc: t('commodityBrokerage.whiteMushrooms.desc'), 
    //       photo: '/white-mushrooms-3.jpg',
    //       isModal: true,

    //       modalPhotos: [
    //         '/mushrooms/photo_2025-02-12_14-45-04.jpg',
    //         '/mushrooms/photo_2025-02-12_14-45-09.jpg',
    //         '/mushrooms/photo_2025-02-12_14-45-11.jpg',
    //         '/mushrooms/photo_2025-02-12_14-45-07.jpg',
    //         '/mushrooms/photo_2025-02-12_14-45-32.jpg',
    //         '/mushrooms/photo_2025-02-12_14-45-30.jpg',
    //         '/mushrooms/photo_2025-02-12_14-45-25.jpg',
    //         '/mushrooms/photo_4_2025-04-07_15-04-37.jpg',
    //         '/mushrooms/photo_2_2025-04-07_15-04-37.jpg',
    //         '/mushrooms/photo_1_2025-04-07_15-04-37.jpg',
    //         '/mushrooms/photo_7_2025-05-07_21-35-16.jpg',
    //         '/mushrooms/photo_2025-05-13_12-32-16.jpg',

    //       ],
    //       modalDescription: t('commodityBrokerage.whiteMushrooms.desc'),
    //     },
    //     {
    //       title: t('commodityBrokerage.chanterelle.title'), 
    //       desc: t('commodityBrokerage.chanterelle.desc'), 
    //       photo: '/chanterelle.jpg',
    //       isModal: true,

    //       modalPhotos: [
    //         '/mushrooms/photo_2025-02-12_14-45-21.jpg',
    //         '/mushrooms/photo_2025-02-12_14-45-16.jpg',
    //         '/mushrooms/photo_2025-02-12_14-45-19.jpg', 
    //         '/mushrooms/photo_3_2025-04-07_15-04-37.jpg',
    //         '/mushrooms/photo_5_2025-04-07_15-04-37.jpg',
           
    //       ],
    //       modalDescription: t('commodityBrokerage.chanterelle.desc'),
    //     },
    //     {
    //       title: t('commodityBrokerage.morels.title'),
    //       desc: t('commodityBrokerage.morels.desc'),
    //       photo: '/mushrooms/photo_3_2025-04-07_19-41-14 - Copy.jpg',

    //       isModal: true,
    //       modalPhotos: [
    //         '/mushrooms/photo_2_2025-04-07_19-41-14.jpg',
    //         '/mushrooms/photo_3_2025-04-07_19-41-14.jpg',
    //       ],
    //       modalDescription: t('commodityBrokerage.morels.desc')
    //     },
    //     {
    //       title: t('commodityBrokerage.caesar.title'),
    //       desc: t('commodityBrokerage.caesar.desc'),
    //       photo: '/mushrooms/photo_2025-02-12_14-45-14 - Copy.jpg',

    //       isModal: true,
    //       modalPhotos: [
    //         '/mushrooms/photo_2025-02-12_14-45-14.jpg',
    //         '/mushrooms/photo_1_2025-04-07_19-41-14.jpg'
    //       ],
    //       modalDescription: t('commodityBrokerage.caesar.desc')
    //     },
    //     {
    //       title: t('commodityBrokerage.Black trumpets.title'),
    //       desc: t('commodityBrokerage.Black trumpets.desc'),
    //       photo: '/mushrooms/photo_2_2025-05-07_23-13-21.jpg',

    //       isModal: true,
    //       modalPhotos: [
    //         '/mushrooms/photo_2_2025-05-07_23-13-21.jpg',
    //         '/mushrooms/photo_1_2025-05-07_23-13-21.jpg'
    //       ],
    //       modalDescription: t('commodityBrokerage.Black trumpets.desc')
    //     },
    //     {
    //       title: t('commodityBrokerage.Dried Morels.title'),
    //       desc: t('commodityBrokerage.Dried Morels.desc'),
    //       photo: '/mushrooms/photo_3_2025-05-07_23-19-26.jpg',

    //       isModal: true,
    //       modalPhotos: [
    //         '/mushrooms/photo_3_2025-05-07_23-19-26.jpg',
    //         '/mushrooms/photo_2_2025-05-07_23-19-26.jpg',
    //         '/mushrooms/photo_1_2025-05-07_23-19-26.jpg',
    //       ],
    //       modalDescription: t('commodityBrokerage.Dried Morels.desc')
    //     }
    //   ]
    // },

// '/pallets/EPAL EURO pallets.png',
// '/pallets/Screenshot_842.png',
// '/pallets/Рallets with a phytosanitary stamp.png',
// '/pallets/European pallet with phytosanitary stamp 1200 x 800 mm.png',
// '/pallets/European pallet with phytosanitary stamp 1200 x 1000 mm.png',
// '/pallets/European pallet with phytosanitary stamp 1200 x 1000 mm.png',
// '/pallets/Pallet with a phytosanitary stamp.png',
// '/pallets/American pallet.png',
// '/pallets/Pallet 600 x 800 mm.png',
// '/pallets/Pallet.png',
// '/pallets/Pallet 1000 x 1000 mm.png',
// '/pallets/Pallet 500 x 800 mm.png'

    {
      title: t('commodityBrokerage.woodworking.title'),
      products: [
        // {title: t('commodityBrokerage.pallets.title'), desc: t('commodityBrokerage.pallets.desc'), photo: '/wooden-pallets.jpg'},
        {
          title: t('commodityBrokerage.woodworking.folder.title'),
          desc: t('commodityBrokerage.woodworking.folder.desc'),
          photo: '/pallets/EPAL EURO pallets.png',

          isModal: true,
          modalDescription: t('commodityBrokerage.woodworking.folder.desc'),
          modalPhotos: [
            '/pallets/eu_p_1200x800.png',
            '/pallets/p_1200x800.png',
            '/pallets/eu_p_st_1200x800.png',
            '/pallets/eu_p_1200x1000.png',
            '/pallets/p_1200x1000.png',
            '/pallets/us_p_1200x1000.png',
            '/pallets/p_600x800.png',
            '/pallets/p_2100x800__2000x1000.png',
            '/pallets/p_1000x1000.png',
            '/pallets/p_500x800.png',
          ],
        },

      //   {
      //     title: t('commodityBrokerage.woodworking.phytosanitaryStampedPallets.title'),
      //     desc: t('commodityBrokerage.woodworking.phytosanitaryStampedPallets.desc'),
      //     photo: '/pallets/Рallets with a phytosanitary stamp.png'
      //   },
      //   {
      //     title: t('commodityBrokerage.woodworking.europeanPalletWithPhytosanitaryStamp.title'),
      //     desc: t('commodityBrokerage.woodworking.europeanPalletWithPhytosanitaryStamp.desc'),
      //     photo: '/pallets/European pallet with phytosanitary stamp 1200 x 800 mm.png'
      //   },
      //   {
      //     title: t('commodityBrokerage.woodworking.europeanPalletWithPhytosanitaryStampLarge.title'),
      //     desc: t('commodityBrokerage.woodworking.europeanPalletWithPhytosanitaryStampLarge.desc'),
      //     photo: '/pallets/European pallet with phytosanitary stamp 1200 x 1000 mm.png'
      //   },
      //   {
      //     title: t('commodityBrokerage.woodworking.palletWithPhytosanitaryStamp.title'),
      //     desc: t('commodityBrokerage.woodworking.palletWithPhytosanitaryStamp.desc'),
      //     photo: '/pallets/Pallet with a phytosanitary stamp.png'
      //   },


      //   {
      //     title: t('commodityBrokerage.woodworking.americanPallet.title'),
      //     desc: t('commodityBrokerage.woodworking.americanPallet.desc'),
      //     photo: '/pallets/American pallet.png',

      //     isModal: true,
      //     modalPhotos: [
      //     ]
      //   },
      //   {
      //     title: t('commodityBrokerage.woodworking.pallet600x800.title'),
      //     desc: t('commodityBrokerage.woodworking.pallet600x800.desc'),
      //     photo: '/pallets/Pallet 600 x 800 mm.png'
      //   },
      //   {
      //     title: t('commodityBrokerage.woodworking.pallet.title'),
      //     desc: t('commodityBrokerage.woodworking.pallet.desc'),
      //     photo: '/pallets/Pallet.png'
      //   },
      //   {
      //     title: t('commodityBrokerage.woodworking.pallet1000x1000.title'),
      //     desc: t('commodityBrokerage.woodworking.pallet1000x1000.desc'),
      //     photo: '/pallets/Pallet 1000 x 1000 mm.png'
      //   },
      //   {
      //     title: t('commodityBrokerage.woodworking.pallet500x800.title'),
      //     desc: t('commodityBrokerage.woodworking.pallet500x800.desc'),
      //     photo: '/pallets/Pallet 500 x 800 mm.png'
      //   },
      ]
    },

    // {
    //   title: t('Frozen fruits'),
    //   products: [
    //     {
    //       title: t('Raspberry'),
    //       desc: t('Raspberry Description'),
    //       photo: '/frozen-fruits/berries2.jpg',
    //       isModal: true,
    //       modalDescription: t('Raspberry Description'),
    //       modalPhotos: [
    //         '/frozen-fruits/berries2.jpg',
    //         '/frozen-fruits/berries1.jpg',
    //         '/frozen-fruits/berries3.jpg',
    //         '/frozen-fruits/berries4.jpg',
    //       ]
    //     }
    //   ]
    // },

    // {
    //   title: 'Berries',
    //   products: [
    //     {
    //       title: t('commodityBrokerage.Currants Q1.title'),
    //       desc: t('commodityBrokerage.Currants Q1.desc'),
    //       photo: '/berries/photo_3_2025-05-07_21-35-162.jpg',

    //       isModal: true,
    //       modalPhotos: [
    //         '/berries/photo_2_2025-05-07_21-35-16.jpg',
    //         '/berries/photo_1_2025-05-07_21-35-16.jpg',
    //         '/berries/photo_3_2025-05-07_21-35-16.jpg',
    //       ],
    //       modalDescription: t('commodityBrokerage.Currants Q1.desc'),
    //     },
    //     {
    //       title: t('commodityBrokerage.Currants Q2.title'),
    //       desc: t('commodityBrokerage.Currants Q2.desc'),
    //       photo: '/berries/photo_6_2025-05-07_21-35-16.jpg',

    //       isModal: true,
    //       modalPhotos: [
    //         '/berries/photo_6_2025-05-07_21-35-16.jpg',
    //         '/berries/photo_9_2025-05-07_21-35-16.jpg',
    //         '/berries/photo_5_2025-05-07_21-35-16.jpg',
    //       ],
    //       modalDescription: t('commodityBrokerage.Currants Q2.desc'),
    //     },
    //     {
    //       title: t('commodityBrokerage.Wild berries and fruits.title'),
    //       desc: t('commodityBrokerage.Wild berries and fruits.desc'),
    //       photo: '/berries/wild_berries_and_fruits.png',

    //       isModal: true,
    //       modalPhotos: [
    //         '/berries/photo_3_2025-05-07_22-32-42.jpg',
    //         '/berries/photo_8_2025-05-07_22-32-42.jpg',
    //         '/berries/photo_7_2025-05-07_22-32-42.jpg',
    //         '/berries/photo_6_2025-05-07_22-32-42.jpg',
    //         '/berries/photo_5_2025-05-07_22-32-42.jpg',
    //         '/berries/photo_4_2025-05-07_22-32-42.jpg',
    //         '/berries/photo_2_2025-05-07_22-32-42.jpg',
    //         '/berries/photo_2025-05-13_12-37-16.jpg',
    //         '/berries/photo_2025-05-13_12-38-50.jpg',
    //         '/berries/photo_2025-05-13_12-39-54.jpg',
    //       ],
    //       modalDescription: t('commodityBrokerage.Wild berries and fruits.desc'),
    //     }
    //   ]
    // },

    {
      title: t('commodityBrokerage.firewood'),
      products: [
        {
          title: t('commodityBrokerage.dryFirewood.title'), 
          desc: t('commodityBrokerage.dryFirewood.desc'), 
          photo: '/woods/photo_7_2025-03-09_14-43-12 - Copy.jpg',

          isModal: true,
          modalPhotos: [
            '/woods/photo_2_2025-03-09_14-43-12.jpg',
            '/woods/photo_1_2025-03-09_14-43-12.jpg',
            '/woods/photo_3_2025-03-09_14-43-12.jpg',
            '/woods/photo_4_2025-03-09_14-43-12.jpg',
            '/woods/photo_5_2025-03-09_14-43-12.jpg',
            '/woods/photo_6_2025-03-09_14-43-12.jpg',
          ],

          modalDescription: t('commodityBrokerage.dryFirewood.modalDescription')
        },
        {
          title: t('commodityBrokerage.pellets.title'),
          desc: t('commodityBrokerage.pellets.desc'),
          photo: '/pellets/photo_1_2025-03-09_15-19-10.jpg',

          isModal: true,
          modalPhotos: [
            'pellets/photo_1_2025-03-09_15-19-10.jpg',
            'pellets/photo_2_2025-03-09_15-19-10.jpg'
          ],
          modalDescription: t('commodityBrokerage.pellets.desc')
        }
      ]
    },

    // {
    //   title: t('commodityBrokerage.cardboard.title'),
    //   products: [
    //     // {
    //     //   title: t('commodityBrokerage.cardboard.cardboardPackaging.title'),
    //     //   desc: t('commodityBrokerage.cardboard.cardboardPackaging.desc'),
    //     //   photo: "/cardboard/corrugated-containers.png",

    //     //   isModal: true,
    //     //   modalPhotos: [
    //     //     "/cardboards/corrugated_packaging.png",
    //     //     '/cardboards/cardboard_corners.png',
    //     //     "/cardboards/cardboard_pallet.png",
    //     //     "/cardboards/cardboard_paper.png",
    //     //     "/cardboards/cardboard_sleeve1.png",
    //     //     "/cardboards/cardboard1.png",
    //     //     "/cardboards/corrugated_filter.png",
    //     //     "/cardboards/paper_filter_in_boxes.png",
    //     //     "/cardboards/parchment.png",
    //     //   ],
    //     //   modalDescription: t('commodityBrokerage.cardboard.cardboardPackaging.desc'),
    //     // },

    //     {
    //       title: t('commodityBrokerage.cardboard.tapes.title'),
    //       desc: t('commodityBrokerage.cardboard.tapes.desc'),
    //       photo: "/cardboard/polypropylene_tape.png",

    //       isModal: true,
    //       modalPhotos: [
    //         "/cardboards/polypropylene_tape.png",
    //         "/cardboards/scotch_tape.png",
    //         "/cardboards/stretch_film.png",
    //         "/cardboards/shrink_film_pof.png",
    //       ],
    //       modalDescription: t('commodityBrokerage.cardboard.tapes.desc'),
    //     },

    //     // {title: 'Cardboard paper', desc: 'High-quality kraft paper is a relevant and convenient packaging material of our time', photo: '/cardboard/cardboard-paper.png'},
    //     // {title: 'Cardboard pallet', desc: 'Corrugated cardboard pallets: modern and cost-effective packaging with environmental care', photo: '/cardboard/pallet.png'},
    //     // {title: 'Parchment', desc: 'High quality parchment paper for baking and packaging \n\nWe offer you white parchment paper - Drewsen Probarrier greaseproof paper.', photo: '/cardboard/parchment.png'},
    //     // {title: 'Polypropylene tape', desc: 'Polypropylene tape with an adhesive layer is a versatile material for convenient packaging', photo: '/cardboard/polypropylene_tape.png'},
    //     // {title: 'Scotch tape', desc: 'Packing tape', photo: '/cardboard/scotch-tape.png'},
    //     // {title: 'Stretch film', desc: 'Neatly stacked rolls of clear stretch film, ready for secure packaging. The sturdy cardboard cores ensure easy handling and dispensing.', photo: '/cardboard/stretch-film.png'},
    //     // {title: 'Shrink film POF', desc: 'High-quality shrinkable POF film, the perfect solution for high-quality packaging', photo: '/cardboard/shrink_film.png'},
    //     // {title: 'Corrugated filter', desc: 'Reliable corrugated filler for packaging products of online stores and enterprises ', photo: '/cardboard/corrugated_filler.png'},
    //     // {title: 'Paper filler in boxes', desc: 'Paper filler for packaging dishes and other fragile goods - PAPER BOX', photo: '/cardboard/paper_filler_in_boxes.png'},
    //     // {title: 'Cardboard corners', desc: 'Cardboard corners for packaging - reliable protection of products', photo: '/cardboard/cardboard_corner.png'},
    //     // {title: 'Cardboard sleeve', desc: 'Sturdy cardboard sleeves for secure shipping. Durable tubes for product protection.', photo: '/cardboard/cardboard_sleeve.png'},
    //     // {title: 'Cardboard', desc: 'Cardboard products are the optimal and safe solution for a wide variety of needs', photo: '/cardboard/cardboard.png'},
    //     // {title: 'Corrugated packaging, corrugated containers', desc: 'A simple, open cardboard box, ready to hold and protect its contents.', photo: '/cardboard/corrugated-containers.png'}
   
   
   
    //   ]
    // },
    {
      title: t('commodityBrokerage.plastic.title'),
      desc: "...",
      products: [
        {
          title: t('commodityBrokerage.plastic.agrochemicalContainers.title'),
          photo: "agrochemical_containers/agrochemical_containers_preview.png",
          desc:  t('commodityBrokerage.plastic.agrochemicalContainers.desc'),

          isModal: true,
          modalPhotos: [
            "agrochemical_containers/Screenshot_846.png",
            "agrochemical_containers/Screenshot_847.png",
            "agrochemical_containers/Screenshot_848.png",
            "agrochemical_containers/Screenshot_849.png",
            "agrochemical_containers/Screenshot_850.png",
            "agrochemical_containers/Screenshot_851.png",
            "agrochemical_containers/Screenshot_893.png",
            "agrochemical_containers/Screenshot_894.png",
            "agrochemical_containers/Screenshot_895.png",
            "agrochemical_containers/Screenshot_896.png",
            "agrochemical_containers/Screenshot_897.png",
            "agrochemical_containers/Screenshot_898.png",
            "agrochemical_containers/Screenshot_899.png",
            "agrochemical_containers/Screenshot_900.png",
            "agrochemical_containers/Screenshot_901.png",
            "agrochemical_containers/Screenshot_902.png",
          ],
          modalDescription: t('commodityBrokerage.plastic.agrochemicalContainers.modalDescription'),
    
          modalPhotosHeight: '!h-auto',
        }
        
      ]
    },

    {
      title:  t('commodityBrokerage.presentations.title'),
      products: [
        {
          title: t('commodityBrokerage.presentations.formworks_timbers_clt.title'),
          photo: '/presentations/Screenshot_927.png',
          desc: t('commodityBrokerage.presentations.desc'),

          isDocument: true,
          document: 'Formworks, timbers, CLT Pannels.pdf'
        },
        {
          title: t('commodityBrokerage.presentations.beams_rebars.title'),
          photo: '/presentations/Screenshot_929.png',
          desc: t('commodityBrokerage.presentations.desc'),

          isDocument: true,
          document: 'Beams, rebars, hollow sections.pdf'
        },
        {
          title: t('commodityBrokerage.presentations.Stainless steel'),
          photo: '/presentations/Screenshot_934.png',
          desc: t('commodityBrokerage.presentations.desc'),

          isDocument: true,
          document: 'Stainless steel.pdf'
        },
      ],

    }
  ]

  return (
    <section ref={ref} className='commodity-brokerage-section'>

        <div className='product-portfolio-title'> 
          <h1>{t('commodityBrokerage.productPortfolioTitle')} <span className='text-[#65a665]'>{t('commodityBrokerage.productPortfolioHighlight')}</span></h1>
        </div>
        <div className='text'>

          <p className={`description`}>
            {t('commodityBrokerage.description')}
          </p>

        </div>
      <div className='products'>
       {productsCardsData.map((card, i) => <ProductsCard key={i} index={i} {...card} />)}
      </div>
    </section>
  )
}

export default CommodityBrokerage
